export default {
  setFeedList(state, payload) {
    state.feedList = payload;
  },
  setSentiment(state, payload) {
    const feed = state.feedList.find((x) => x.id == payload.feedId);

    if (feed) {
      feed.sentimentId = payload.sentimentId;
    }
  },
  setTotalFeedCount(state, payload) {
    state.totalFeedCount = payload;
  },
  setFeedTypes(state, payload) {
    state.feedTypeList = payload;
  },
  setAnswerTypes(state, payload) {
    state.answerTypeList = payload;
  },
};